import { render } from "./NotificationsPage.vue?vue&type=template&id=08a9916e&ts=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=ts"
export * from "./NotificationsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__